import { useMemo } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import {
  CheckoutSessionData,
  GET_ACCOUNT_QUERY,
  POST_CHECKOUT_SESSION,
} from "../../../api/Requests";
import { useMutation } from "@apollo/client";
import { PiConfettiThin } from "react-icons/pi";
import client from "../../../api/ApiClient";

function useRouterQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

export default function Return() {
  const myRouterQuery = useRouterQuery();
  const sessionId = myRouterQuery.get("session_id");
  const [checkoutSessionCreate, { data, loading, error }] =
    useMutation<CheckoutSessionData>(POST_CHECKOUT_SESSION);

  useMemo(() => {
    if (sessionId) {
      return checkoutSessionCreate({
        variables: {
          input: { sessionId },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  if (loading) {
    return <p>Loading...</p>;
  }
  if (error) {
    return <p>Error: {error.message}</p>;
  }

  if (data?.checkoutSession.status === "open") {
    // Remount embedded Checkout
    return <Navigate to="/plans" />;
  }

  if (data?.checkoutSession.status === "complete") {
    // Force a refetch of the account data after the subscription is created
    client.refetchQueries({
      include: [GET_ACCOUNT_QUERY],
    });
  }
  return (
    <div className="pageContainer">
      {data?.checkoutSession.status === "complete" ? (
        <div>
          <h1>You have successfully subscribed to easyzilla!</h1>
          <h2>
            <PiConfettiThin /> Thank you for your purchase.
          </h2>
          <p>
            <Link to="/info">
              Get started by importing some information for your Webpage
            </Link>
          </p>
          <p>
            <Link to="/webpage#top">Edit Your Webpage</Link>
          </p>
          <p>
            <Link to="/settings">Publish Your Webpage</Link>
          </p>
        </div>
      ) : (
        <div>
          <h1>Subscription failed</h1>
          <h2>Please contact support to finish subscription process.</h2>
          <p>Session Id: {sessionId}</p>
          <p>Session Status: {data?.checkoutSession.status}</p>
        </div>
      )}
    </div>
  );
}
